exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n  .contactText{\n      text-align: center;\n      margin: 40px 40px;\n      color: #646161;\n      font-size: 16px;\n      letter-spacing: 1px;\n      line-height: 25px;\n  }\n\n  .separatorLine{\n    display: block;\n    width: 1px;\n    height: 100px;\n    background: #dedede;\n    margin: 0 auto;\n  }", ""]);

// exports
